import { Card, Help, useGet } from '@enkla-gui'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { loader, notify } from '@/_helpers'

import Greeting from '@components/layout/Greeting'
import Modal from 'react-modal'
import { UserContext } from '@/App'

export default function Onboard() {
  const [activeGroup, setActiveGroup] = useState(null);
  const [selectedTask, setSelectedTask] = useState(false);
  const [show, setShow] = useState(false);
  const { task, setTask, tasks: taskgroup, refetchtasks } = useContext(UserContext)
  const activeGroupIndex = useMemo(() => {
    if (!taskgroup || !activeGroup) return 0
    return taskgroup.findIndex(t => t.title === activeGroup.title);
  }, [taskgroup, activeGroup]);

  useEffect(() => {
    if (!taskgroup) return
    const found = taskgroup.find(group => group.tasks.some(task => !task.completed));
    setActiveGroup(found || taskgroup[0]);
  }, [taskgroup])

  useEffect(() => {
    refetchtasks();
    setTask(null)
  }, [])

  const onTaskClick = task => {
    if (task.locked) return notify.toast('Detta steg är låst tills att du utfört de tidigare stegen', 'info')

    if (typeof task.redirectOptions === 'object') {
      if (Object.entries(task.redirectOptions).length === 1) {
        setTask({ ...task, redirectOptions: Object.entries(task.redirectOptions)[0][1] })
        window.location.hash = Object.entries(task.redirectOptions)[0][1]
      } else {
        setSelectedTask(task)
      }
    } else {
      setTask({ ...task })
      window.location.hash = task.redirectOptions
    }
  }

  if (!taskgroup || activeGroup === null) return loader.content()
  //vet att den här är copy paste men det var in the heat of  the moment 4  maria
  const getAllCompletion = () => {
    if (!taskgroup) return
    var totaltasks = 0;
    var completedtasks = 0;
    for (var tg of taskgroup) {
      totaltasks += tg.tasks.length
      completedtasks += tg.tasks.filter(t => t.completed).length
    }
    return Math.floor((completedtasks / totaltasks) * 100);
  }
  const completedPercent = Math.floor((activeGroup.tasks.filter(t => t.completed).length / activeGroup.tasks.length) * 100)
  const completed = `${completedPercent}%`


  const getEncouragement = (percent) => {
    if (percent === 0)
      return { icon: 'fa-rocket', text: 'Påbörja konfigurationen genom att slutföra första steget.' }

    if (percent < 33)
      return { icon: 'fa-seedling', text: 'Konfigurationen är påbörjad.' }

    if (percent < 66)
      return { icon: 'fa-fire', text: 'Cirka hälften av stegen är slutförda.' }

    if (percent < 100)
      return { icon: 'fa-star', text: 'De flesta stegen är slutförda.' }

    return {
      icon: 'fa-trophy',
      text: 'Alla steg i denna sektion är slutförda.'
    }
  }
  const encouragement = getEncouragement(completedPercent)
  return (
    <>
      <Greeting greeting='Välkommen till Enkla Fastigheter, här hjälper vi dig komma igång.' />
      {getAllCompletion() === 100 && !show ?
        <div class="row">
          <Help header={false} type='primary' icon={null}>
            <p>Grattis! Du har nu gått igenom vår guide och tagit de första stegen för att komma igång. Vi hoppas att den har gett dig en tydlig bild av hur allt fungerar och att du känner dig redo att utforska vidare.</p>
            <p>Att komma igång kan ibland innebära en del nya begrepp och funktioner, men ingen stress – du lär dig i din egen takt. Om du stöter på något du är osäker på kan du alltid ta en titt i vår FAQ genom att klicka på frågetecknet nere till vänster. Där har vi samlat svar på vanliga frågor och praktiska tips.</p>
            <p>Skulle du behöva mer hjälp eller ha specifika frågor är du alltid välkommen att kontakta oss. Vi finns här för att se till att du får den bästa möjliga upplevelsen.</p>
            <p>Vill du kika på guiden igen ? <a class="btn-link text-white" onClick={() => setShow(true)} >Klicka här för att visa den på nytt</a>.</p>
            <p>Vill du dölja knappen "Kom igång" i sidomenyn? <a class="btn-link text-white" href="#/setting/user" >Klicka här</a>.</p>
          </Help>
          <div>
            <div class="bicflex">
              <img style={{ 'width': '50%', 'padding': '50px 0px' }} src='images/completed-task-7.svg' />
            </div>
          </div>
        </div>
        :
        <>
          <div className='onboarding-overview'>
            <div className='onboarding-sections'>
              {taskgroup.map((group, index) => {
                const groupCompleted = group.tasks.every(task => task.completed)
                return (
                  <button
                    type='button'
                    className={`onboarding-section ${index === activeGroupIndex ? 'active' : ''} ${groupCompleted ? 'completed' : ''}`}
                    onClick={() => setActiveGroup(group)}
                    key={group.title}
                  >
                    <span className='onboarding-section-icon'>
                      {groupCompleted ? <i className='fas fa-check' /> : index + 1}
                    </span>
                    <span>{group.title}</span>
                  </button>
                )
              })}
            </div>

            <div className='taskgroup-info'>
              <div className='taskgroup-desc' dangerouslySetInnerHTML={{ __html: activeGroup.description }} />
              <div className='onboarding-progress'>
                <div className='onboarding-progress-header'>
                  <span>Framsteg i sektionen</span>
                  <strong>{completed}</strong>
                </div>
                <div className='progress'>
                  <div className={`progress-bar ${completed === '100%' && 'bg-primary'}`} role='progressbar' style={{ width: completed }} aria-valuenow={completedPercent} aria-valuemin='0' aria-valuemax='100' />
                </div>
                <div className='progress-encouragement'>
                  <i className={`fas ${encouragement.icon}`}></i>
                  <span>{encouragement.text}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row no-margin">
            <div className="card no-padding">
              {activeGroup.tasks.map((task, idx) => (
                <div className="taskk-wrapper" key={idx} onClick={e => onTaskClick(task)}>
                  <div className="task-icon">
                    <i className={task.icon}></i>
                  </div>
                  <div className="task-content">
                    <span>{task.title}</span>
                    <small>{task.description}</small>
                  </div>
                  <div className={`task-status ${task.locked ? 'locked' : task.completed ? 'completed' : ''}`}>
                    <i className={task.locked ? 'fas fa-lock' : task.completed ? 'fas fa-check' : 'fas fa-arrow-right'} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Modal isOpen={selectedTask} onRequestClose={() => setSelectedTask(false)} className='no-padding'>
            <Card title={selectedTask?.title} icon={selectedTask.icon}
              collapsed={null}
            >
              {selectedTask !== false && (
                <ul class="list-unstyled" style={{ padding: '10px' }}>
                  {Object.entries(selectedTask.redirectOptions).map(([key, value]) => (
                    <li><a class="btn btn-primary w-100 mb-2" href={'#' + value}>{key}</a></li>
                  ))}
                </ul>
              )}
            </Card>
          </Modal>
        </>
      }
    </>
  )
}
